// Function to capitalize each word in a string
export function formatRoleName(role: string): string {
    const formattedRole = role.replace(/[_-]/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    if (formattedRole === 'Basic') return 'Free';
    if (formattedRole === 'Prcl') return '$PRCL';
    return formattedRole;
  }